// @flow
import Properties from "../../../Properties";
import { getInit, postInit, graphQLInit } from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import {
  BillingCompanyNode,
  BillingProductPartNode,
  BillingHistoryNode
} from "../types/GraphQlNodes";
import { apiFailCallbackHandle } from "../containers/ErrosDisplay";
import {
  GET_BILLING_COMPANY,
  GET_CURRENT_BILLING,
  GET_HISTORY_BILLINGS,
  GET_HISTORY_BILLING_DETAIL,
  ADMIN_GET_HISTORY_BILLING_DETAIL
} from "../../global/actions/actionNames";

const root = Properties.api_root;

export const fetchCurrentBilling = (): * => (
  dispatch: DispatchType
): DispatchType => {
  const graphQl = `
  {
    company{${BillingCompanyNode}}
    currentBilling{
      total
      items{${BillingProductPartNode}}
    }
    historyBillings{${BillingHistoryNode}}
  }
  `;
  return fetch(`${root}/api/v2/price/graphql`, graphQLInit(graphQl))
    .then((response: Response): * => response.json())
    .then(
      (json: *): * => {
        dispatch({ type: GET_BILLING_COMPANY, company: json.data.company });
        dispatch({
          type: GET_CURRENT_BILLING,
          currentBilling: json.data.currentBilling
        });
        dispatch({
          type: GET_HISTORY_BILLINGS,
          historyBillings: json.data.historyBillings
        });
      }
    );
};

export const fetchHistoryBilling = (
  billingId: string,
  companyId?: string
): * => (dispatch: DispatchType): DispatchType => {
  const graphQl = `
  {
    historyBillingLogs(id: "${billingId}"){
      ${BillingProductPartNode}
    }
  }
  `;
  return fetch(`${root}/api/v2/price/graphql`, graphQLInit(graphQl))
    .then((response: Response): * => response.json())
    .then(
      (json: *): * => {
        if (companyId) {
          dispatch({
            type: ADMIN_GET_HISTORY_BILLING_DETAIL,
            billindId: billingId,
            companyId: companyId,
            logs: json.data.historyBillingLogs
          });
        } else {
          dispatch({
            type: GET_HISTORY_BILLING_DETAIL,
            billindId: billingId,
            logs: json.data.historyBillingLogs
          });
        }
      }
    );
};
